(() => {
  // 10/7 번체 중국어 — i18n.js 와 같게: 홍콩 · 마카오는 zh-HK, 그 밖의 중국어는 zh-TW(설명 사전 scene-detail-zh-TW · zh-HK.json)
  const supported = value => /^zh(?:[-_]|$)/i.test(String(value || '')) ? (/^zh(?:[-_]hant)?[-_](?:hk|mo)(?:[-_]|$)/i.test(String(value)) ? 'zh-HK' : 'zh-TW') : /^(ko|en|ja)(?:[-_]|$)/i.exec(String(value || ''))?.[1].toLowerCase();
  let saved; try { saved = localStorage.getItem('bamgwabi.locale'); } catch {}
  const locale = window.BGLANG?.locale || (window.BGTOSS ? 'ko' : supported(new URLSearchParams(location.search).get('lang')) || supported(saved) || supported(document.documentElement.dataset.regionLocale) || 'ko');
  document.documentElement.lang = locale;
  const ready = locale === 'ko' ? Promise.resolve(null) : fetch(`/app/data/scene-detail-${locale}.json`, { cache: 'no-cache' }).then(r => {
    if (!r.ok) throw new Error('Scene detail language unavailable');
    return r.json();
  }).catch(() => null);
  ready.then(detail => {
    const label = { en: 'All results are free', ja: 'すべての結果が無料', 'zh-TW': '所有結果免費', 'zh-HK': '全部結果免費' }[locale];
    for (const guide of Object.values(detail?.q || {})) if (guide.meta?.[0] && label) guide.meta[0][0] = label;
  });
  window.BGSCENEDETAIL = { locale, ready };
  ready.then(detail => {
    const topic = new URLSearchParams(location.search).get('topic') || 'T01';
    // 10/7 사장님 「형식 맞춰서」 — 탭 제목은 「내용 | 이름」(일본어 夜と雨)
    if (detail?.info?.[topic]) document.title = `${detail.info[topic].title} | ${locale === "ja" ? "夜と雨" : /^zh-/.test(locale) ? "夜與雨" : locale === "ko" ? "밤과비" : "Night & Rain"}`;   // 10/7 번체 중국어 — 「夜與雨」
  });
  const back = document.querySelector('.topbar a');
  if (back) {
    back.href = `/?lang=${locale}#home`;
    if (locale !== 'ko') back.setAttribute('aria-label', locale === 'ja' ? 'ホームに戻る' : locale === 'zh-TW' ? '回首頁' : locale === 'zh-HK' ? '返回首頁' : 'Back to home');   // 10/7 번체 중국어
  }
})();
